import { inventoryItemIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";
import { unboxingVideoContentType } from "./get-unboxing-video-upload-url";

/**
 * Upload slot keyed by the physical package, so the video can upload before
 * any return exists; setReturnUnboxingVideo associates the key later.
 */
export const getInventoryUnboxingVideoUploadUrl = {
  name: "getInventoryUnboxingVideoUploadUrl" as const,
  input: z.object({
    inventoryItemId: inventoryItemIdFormat.schema,
    contentType: z.enum(unboxingVideoContentType),
  }),
  output: z.object({
    uploadUrl: z
      .string()
      .describe("Presigned S3 PUT URL the browser uploads the video to"),
    key: z.string().describe("S3 object key the video is stored at"),
  }),
};
